import React, { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import idx from "idx";
import { useLocalStorage } from "./common/hooks";
import Gettext from "./common/Gettext";
import { StyledPopup } from "./Tournaments/Popups/Popup";
import Button from "./Buttons/FlatButton";
import { ModalConsumer } from "./common/ModalProvider";
import TournamentApi from "./Tournaments/Api";

const Title = styled.div`
  width: 100%;
  margin: 0 auto 40px;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: ${({ theme }) => theme.foreground};
  text-align: center;

  @media (min-width: 960px) {
    max-width: 300px;
  }

  @media (max-width: 959px) and (min-width: 480px) {
    padding-right: 32px;
    padding-left: 32px;
  }
`;

const Text = styled.span`
  margin-bottom: 40px;
  color: #96949b;
  text-align: center;
`;

const LaterButton = styled.button`
  margin-top: 40px;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  color: ${({ theme }) => theme.alternativeAccent};
  text-decoration: underline;
  background: transparent;
  border: none;
  border-radius: none;
  cursor: pointer;

  ${({ theme }) =>
    theme.direction === "rtl" &&
    css`
      font-size: 16px;
    `};

  :hover,
  :focus,
  :active {
    text-decoration: none;
  }
`;

const InvitePopup = props => {
  const onDismiss = () => {
    props.addTournamentToShowedList();
    props.onDismiss();
  };

  const popupProps = { ...props, onDismiss, mobileColumn: true };

  return (
    <StyledPopup {...popupProps}>
      <Title>
        <Gettext>Use your invitation!</Gettext>
      </Title>
      <Text>
        {/*prettier-ignore*/}
        <Gettext>
          You've got a free invitation to the tournament {<span><br />"{props.info.title}"</span>}.
        </Gettext>
      </Text>
      <Button
        onClick={() => {
          props.addTournamentToShowedList();
          props.onDismiss();
        }}
        to={`/tournaments/${props.info.id}`}
      >
        <Gettext>Join</Gettext>
      </Button>
      <LaterButton
        onClick={() => {
          props.addTournamentToShowedList();
          props.onDismiss();
        }}
      >
        <Gettext>Later</Gettext>
      </LaterButton>
    </StyledPopup>
  );
};

const Invite = ({ showModal, item, addTournamentToShowedList }) => {
  useEffect(() => {
    showModal(InvitePopup, { ...item, addTournamentToShowedList });
  }, []);

  return null;
};

const TournamentInvite = () => {
  const api = useContext(TournamentApi);
  const [info, setInfo] = useState(null);

  const [showedTournaments, setShowedTournaments] = useLocalStorage(
    "showed_invited_tournament_popups",
    []
  );

  useEffect(() => {
    const f = async () => {
      const announcementsData = await api.readEntity("/api/bell-tolls-items");

      const announcements = idx(announcementsData, n => n.value.payload);

      const tournaments =
        announcements &&
        announcements.data.filter(item => {
          if (
            item.type === "invited-tournament" &&
            item.timestamp > announcements.lastViewTimestamp &&
            item.info.state !== 2 &&
            item.show_modal === true &&
            item.info.participation_status === 0
          ) {
            if (showedTournaments.length > 0) {
              const storageTournament = showedTournaments.find(
                tournament =>
                  tournament.id === item.info.id &&
                  tournament.timestamp === item.timestamp
              );

              if (storageTournament !== undefined) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          } else {
            return false;
          }
        });

      setInfo(tournaments);
    };

    if (api != null) {
      f();
    }
  }, [api]);

  const addTournamentToShowedList = tournament => {
    const showedTournaments = JSON.parse(
      window.localStorage.getItem("showed_invited_tournament_popups")
    );

    const filteredList = showedTournaments.filter(
      item => tournament.id !== item.id
    );

    setShowedTournaments([...filteredList, tournament]);
  };

  if (info == null) return null;

  return (
    <ModalConsumer>
      {({ showModal }) => (
        <React.Fragment>
          {info.map(item => {
            return (
              <Invite
                showModal={showModal}
                addTournamentToShowedList={() =>
                  addTournamentToShowedList({
                    id: item.info.id,
                    timestamp: item.timestamp
                  })
                }
                item={item}
              />
            );
          })}
        </React.Fragment>
      )}
    </ModalConsumer>
  );
};

export default TournamentInvite;



// WEBPACK FOOTER //
// ./src/components/TournamentInvite.js